module.exports = __webpack_public_path__ + "static/media/hermionegranger.876784d9.jpeg";